const ModalCloseButton = {
    baseStyle: {
        borderRadius: '50%',
    },
    defaultProps: {},
    variants: {},
};
export default ModalCloseButton;
